import { useGetBranchesQuery } from "@/react/services/common/branchesApi";
import DynamicSelectCell from "./DynamicSelectCell";

const BranchNameSelect = (props) => {
  const { data, isFetching } = useGetBranchesQuery();

  const options = (data || []).map((branch) => ({
    value: branch.name,
    label: branch.name,
  }));

  return (
    <DynamicSelectCell
      {...props}
      options={options}
      isFetching={isFetching}
      testId={"branch-name-select"}
      placeholder={"Select Branch Name"}
    />
  );
};

export default BranchNameSelect;
